export default __webpack_public_path__ + "static/media/2.927be2ab.png";